export const DELETE_WIDGET = "DELETE_WIDGET";
export const DELETE_TAB = "DELETE_TAB";
export const RESET_SETTINGS = "RESET_SETTINGS";
export const CUSTOM_OK_CANCEL = "CUSTOM_OK_CANCEL";
export const USER_INPUT = "USER_INPUT";
export const DOCK_WIDGET = "DOCK_WIDGET";
export const HOST_ELEMENT = "HOST_ELEMENT";
